import * as Yup from "yup";
import "yup-phone";

export const RestrictionSchemaForClientReportTemplate = (t, role) => Yup.object({
  firmId: Yup.string().required(t("string-literals.report-template-firmId")),
  clientId: Yup.string().required(t("string-literals.report-template-clientId")),
  // modalityId: Yup.array()
//   .of(Yup.string().required())
  // .min(1, t("string-literals.report-template-modality-list"))
  // .required(t("string-literals.report-template-modality-list"))
});
